import SectionHeader from "../shared/SectionHeader";

export function EmptySectionPlaceholder({ title }: { title: string }) {
  return (
    <div className="tw-space-y-4">
      <SectionHeader title={title} />
      <div className="tw-rounded-lg tw-border tw-p-4 tw-bg-white tw-flex tw-flex-col tw-gap-4">
        <p className="tw-text-muted-foreground tw-h-[200px]">
          {title} section is coming soon!
        </p>
      </div>
    </div>
  );
}
